import moment from 'moment-timezone';
import React, { Fragment, useMemo } from 'react';
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaUpload } from "react-icons/fa6";

const SelectionSummaryPanel = ({
  selectedEvents = [],
  onRemove,
  onSave,
  saving = false,
  onReset,
  handleOpenSiteDialog,
  userDetails,
  logs
}) => {
  const { singles, parlays } = useMemo(() => {
    const stats = { singles: 0, parlays: 0 }
    selectedEvents.forEach((event) => {
      if (event.single) stats.singles += 1
      if (event.parlay) stats.parlays += 1
    })
    return stats
  }, [selectedEvents])

  return (
    <aside className="flex flex-col gap-4 rounded-2xl border border-customAccent/20 bg-white/90 p-4 shadow-lg shadow-customAccent/10 dark:border-customSurfaceMuted dark:bg-customSurface">
      <header>
        <div className='flex justify-between items-center'>
          <h2 className="text-lg font-semibold text-customInk dark:text-customHeading">Selection desk</h2>
          {/* <div className='flex items-center gap-2'>
            <MdViewColumn
              size={15}
              className={`${view === 'column' ? 'text-customAccent' : 'text-customInk'} dark:text-customHeading`}
              onClick={() => setIsView('column')}
            />
            <MdViewStream
              size={15}
              className={`${view === 'stream' ? 'text-customAccent' : 'text-customInk'} dark:text-customHeading`}
              onClick={() => setIsView('stream')}
            />
          </div> */}
        </div>
        <p className="text-xs text-customSecondaryText dark:text-customMuted">
          Review picks before pushing to betting pages. Singles and parlays are saved independently so
          you can stage either side first.
        </p>
      </header>
      <div className="flex items-center justify-between rounded-2xl border border-customAccent/10 bg-customSlate/60 px-4 py-3 text-sm font-semibold text-customInk dark:border-customSurfaceMuted dark:bg-customSurfaceMuted/60 dark:text-customHeading">
        <span>Total events</span>
        <span>{selectedEvents.length}</span>
      </div>
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div className="rounded-2xl border border-customAccent/20 bg-customAccent/10 px-3 py-2 text-customAccent dark:border-customAccent/40 dark:bg-customAccent/60 dark:text-customHeading">
          <p className="text-[11px] uppercase tracking-wide">Singles</p>
          <p className="text-lg font-semibold">{singles}</p>
        </div>
        <div className="rounded-2xl border border-customVibrantGreen/20 bg-customVibrantGreen/10 px-3 py-2 text-customVibrantGreen dark:border-customVibrantGreen/40 dark:bg-customVibrantGreen/60 dark:text-customHeading">
          <p className="text-[11px] uppercase tracking-wide">Parlays</p>
          <p className="text-lg font-semibold">{parlays}</p>
        </div>
      </div>
      {/* <div className="grid max-h-[360px] gap-3 overflow-y-auto pr-1 text-sm">
        {selectedEvents.length ? (
          selectedEvents.map((event) => (
            <article
              key={`${event.id}-${event.single ? 'S' : ''}${event.parlay ? 'P' : ''}`}
              className="rounded-2xl border border-customAccent/15 bg-customLightMilkWhite/70 px-3 py-3 shadow-sm transition hover:border-customAccent/25 dark:border-customSurfaceMuted dark:bg-customSurfaceMuted/60"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="truncate text-sm font-semibold text-customInk dark:text-customHeading">
                    {event.homeTeam} vs {event.awayTeam}
                  </p>
                  <p className="mt-0.5 text-[11px] uppercase tracking-wide text-customMuted">
                    {event.leagueName}
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => onRemove?.(event.id)}
                  className="shrink-0 rounded-lg border border-transparent px-2 py-1 text-[11px] font-semibold text-customAccent transition hover:border-customAccent/30 hover:bg-customAccent/10 focus:outline-none focus:ring-1 focus:ring-customAccent/40 dark:text-customHeading"
                >
                  Remove
                </button>
              </div>
              <div className="mt-3 flex flex-wrap items-center gap-2">
                {event.single ? (
                  <span className="rounded-full bg-customAccent/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-customAccent dark:bg-customAccent/20 dark:text-customHeading">
                    Single
                  </span>
                ) : null}
                {event.parlay ? (
                  <span className="rounded-full bg-customVibrantGreen/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-customVibrantGreen dark:bg-customVibrantGreen/20 dark:text-customHeading">
                    Parlay
                  </span>
                ) : null}
                <span className="rounded-full bg-customSlate px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-customSecondaryText dark:bg-customSurface dark:text-customMuted">
                  Handicap {event.handicap?.line ?? event.handicap ?? 'N/A'}
                </span>
              </div>
            </article>
          ))
        ) : (
          <p className="rounded-2xl border border-dashed border-customAccent/20 bg-customSlate/40 px-4 py-6 text-center text-xs text-customSecondaryText dark:border-customSurfaceMuted dark:bg-customSurfaceMuted/40 dark:text-customMuted">
            Select events from the table to build your save list. Singles and parlays can be saved independently.
          </p>
        )}
      </div> */}
      <ActionZone
        onSave={onSave}
        saving={saving}
        onReset={onReset}
        handleOpenSiteDialog={handleOpenSiteDialog}
        selectedEvents={selectedEvents}
        userDetails={userDetails}
        logs={logs}
      />
    </aside>
  )
}

export default SelectionSummaryPanel;

const ActionZone = ({ logs, onSave, handleOpenSiteDialog, onReset, saving, selectedEvents, userDetails }) => {
  const actionState = useMemo(() => {
    const operationalMoment = moment().tz('Asia/Yangon')
    const bettingDate = operationalMoment.hours() >= 12
      ? operationalMoment.clone()
      : operationalMoment.clone().subtract(1, 'day')

    const lastSavedAt = logs?.save_all ? new Date(logs.save_all) : null
    const lastMultipleSavedAt = logs?.save_multiple ? new Date(logs.save_multiple) : null
    const hasSavedToday =
      Boolean(lastSavedAt) &&
      !Number.isNaN(lastSavedAt.getTime()) &&
      moment(lastSavedAt).tz('Asia/Yangon').format('YYYY-MM-DD') === bettingDate.format('YYYY-MM-DD')

    return {
      bettingDateLabel: bettingDate.format('DD MMM YYYY'),
      lastSavedLabel: formatRelative(lastSavedAt),
      lastMultipleSavedLabel: formatRelative(lastMultipleSavedAt),
      hasSavedToday,
      canSave: !hasSavedToday && !saving && selectedEvents.length > 0,
      canSaveMultiple: hasSavedToday && !saving,
    }
  }, [logs?.save_all, logs?.save_multiple, saving, selectedEvents.length])

  return (
    <div className="mt-auto grid gap-3">
      {/* <div className="rounded-3xl border border-customAccent/15 bg-[linear-gradient(135deg,rgba(17,24,39,0.98),rgba(24,62,143,0.94))] p-4 text-customWhite shadow-xl shadow-customAccentBlue/15">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="space-y-2">
            <span className="inline-flex items-center rounded-full border border-white/15 bg-white/10 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.24em] text-white/80">
              Betting window
            </span>
            <div>
              <p className="text-lg font-semibold text-white">Action Zone</p>
              <p className="text-xs text-white/70">
                Queue and lock today&apos;s betting actions with a dated save cycle.
              </p>
            </div>
          </div>
          <div className="rounded-2xl border border-white/15 bg-white/10 px-3 py-2 text-right">
            <p className="text-[10px] uppercase tracking-[0.22em] text-white/60">Betting date</p>
            <p className="text-sm font-semibold text-white">{actionState.bettingDateLabel}</p>
          </div>
        </div>
        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          <StatusTile
            label="Main queue"
            value={actionState.lastSavedLabel}
            tone={actionState.hasSavedToday ? 'success' : 'default'}
          />
          {userDetails?.companyId === "909" ? (
            <StatusTile
              label="Multiple queue"
              value={actionState.lastMultipleSavedLabel}
              tone={actionState.canSaveMultiple ? 'success' : 'default'}
            />
          ) : null}
        </div>
      </div> */}
      <div className="grid gap-2.5">
        <button
          type="button"
          onClick={onSave}
          disabled={!actionState.canSave}
          className="group flex min-h-[56px] items-center justify-between gap-2 rounded-2xl border border-customAccentBlue/20 bg-customAccentBlue px-4 py-3 text-left text-white shadow-lg shadow-customAccentBlue/25 transition hover:-translate-y-0.5 hover:bg-customAccentBlue/90 focus:outline-none focus:ring-2 focus:ring-customAccentBlue/40 disabled:translate-y-0 disabled:cursor-not-allowed disabled:border-customAccentBlue/10 disabled:bg-customAccentBlue/50 disabled:shadow-none dark:bg-customAccent dark:text-customHeading"
        >
          <span className="flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-white/14">
              {saving ? (
                <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
              ) : (
                <FaCloudUploadAlt size={16} className="text-customFontMilkWhite" />
              )}
            </span>
            <span>
              <span className="block text-sm font-semibold">
                {saving ? 'Saving selections...' : 'Save to betting'}
              </span>
              <span className="block text-[11px] text-white/70">
                {!actionState.canSave ? 'Already saved for this betting.' : `${selectedEvents.length} event${selectedEvents.length === 1 ? '' : 's'} ready`}
              </span>
               <span className="block text-[11px] text-white/70">
                Last Saved {actionState.lastSavedLabel }
              </span>
            </span>
          </span>
          <span className="rounded-full bg-white/12 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/75">
            Primary
          </span>
        </button>
      {
        userDetails?.companyId === "909" ?
          <Fragment>
            <button
              type="button"
              onClick={handleOpenSiteDialog}
              disabled={!actionState.canSaveMultiple}
              className="flex min-h-[56px] items-center justify-between gap-3 rounded-2xl border border-customVibrantGreen/70 bg-white px-4 py-3 text-left text-customInk shadow-sm transition hover:-translate-y-0.5 hover:border-customVibrantGreen/40 hover:bg-customVibrantGreen/5 focus:outline-none focus:ring-2 focus:ring-customVibrantGreen/30 disabled:translate-y-0 disabled:cursor-not-allowed disabled:border-customSurfaceMuted disabled:bg-customSlate/40 disabled:text-customMuted dark:border-customVibrantGreen/60 dark:bg-customSurface dark:text-customHeading dark:hover:bg-customSurfaceMuted/80"
            >
              <span className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-customVibrantGreen/12 text-customVibrantGreen dark:bg-customVibrantGreen/20 dark:text-customHeading">
                  <FaUpload size={15} />
                </span>
                  <span>
                    <span className="block text-sm font-semibold">Save to multiple betting</span>

                    {actionState.canSaveMultiple ? null :
                      <span className="block text-[11px] text-customSecondaryText dark:text-customMuted">
                        Enabled after the main queue is saved.
                      </span>
                    }
                    {actionState.canSaveMultiple ?
                      <span className="block text-[11px] text-customSecondaryText dark:text-customMuted">
                        Last Multiple Saved {actionState.lastMultipleSavedLabel}
                      </span>
                      : null
                    }
                  </span>
              </span>
              <span className="rounded-full bg-customVibrantGreen/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-customVibrantGreen dark:bg-customVibrantGreen/20 dark:text-customHeading">
                Multi
              </span>
            </button>
          </Fragment> : null
      }
      <button
        type="button"
        onClick={onReset}
        className="flex min-h-[52px] items-center justify-center rounded-2xl border border-customAccent/20 bg-customSlate/50 px-4 py-3 text-sm font-semibold text-customAccent transition hover:border-customAccent/35 hover:bg-customAccent/10 focus:outline-none focus:ring-2 focus:ring-customAccent/25 dark:border-customAccent/30 dark:bg-customSurfaceMuted/60 dark:text-customHeading"
      >
        Clear all
      </button>
    </div>
    </div>
  )
}

const StatusTile = ({ label, value, tone = 'default' }) => {
  const toneClassName = tone === 'success'
    ? 'border-emerald-400/20 bg-emerald-400/10 text-white'
    : 'border-white/10 bg-white/5 text-white'

  return (
    <div className={`rounded-2xl border px-3 py-2 ${toneClassName}`}>
      <div className="flex items-center gap-2">
        <span className="h-2 w-2 rounded-full bg-current opacity-90" />
        <p className="text-[10px] uppercase tracking-[0.22em] text-white/60">{label}</p>
      </div>
      <p className="mt-1 text-sm font-semibold">{value}</p>
    </div>
  )
}

const formatRelative = (timestamp) => {
  if (!timestamp) return 'Never'
  const value = typeof timestamp === 'string' ? new Date(timestamp) : timestamp
  if (Number.isNaN(value?.getTime?.())) return 'Unknown'

  const diffMs = Date.now() - value.getTime()
  if (diffMs < 0) return 'Just now'
  const diffMinutes = Math.floor(diffMs / 1000 / 60)
  if (diffMinutes < 1) return 'Just now'
  if (diffMinutes < 60) return `${diffMinutes} minute${diffMinutes === 1 ? '' : 's'} ago`
  const diffHours = Math.floor(diffMinutes / 60)
  if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`
  const diffDays = Math.floor(diffHours / 24)
  return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`
}

